import { ApiFunc, getInstance } from '@src/helpers/httpClient'
import { dissoc } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const preModerationAll: ApiFunc<`${typeof API.PRE_MODERATION_ALL}`, 'get'> = params =>
  instance.get(API.PRE_MODERATION_ALL, {
    params,
  })

export const preModerationById: ApiFunc<`${typeof API.PRE_MODERATION}{id}`, 'get'> = data =>
  instance.get(`${API.PRE_MODERATION}${'id' in data ? data.id : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const preModerationHistoryCreate: ApiFunc<`${typeof API.PRE_MODERATION_HISTORY_CREATE}`, 'post'> = data =>
  instance.post(API.PRE_MODERATION_HISTORY_CREATE, data)

export const preModerationAssigned: ApiFunc<`${typeof API.PRE_MODERATION_ASSIGNED}`, 'get'> = params =>
  instance.get(API.PRE_MODERATION_ASSIGNED, {
    params,
  })

export const preModerationChangeStatus: ApiFunc<`${typeof API.PRE_MODERATION_CHANGE_STATUS}`, 'put'> = data =>
  instance.put(API.PRE_MODERATION_CHANGE_STATUS, data)
